import type { FC } from 'react';
import {
  Card,
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import Title from '../../../components/admin/Title';
import TableCellHeaderBasic from '../../../components/global/TableCellHeaderBasic';
import Scrollbar from '../../../components/admin/Scrollbar';
import TableCellHeaderSum from '../../../components/global/TableCellHeaderSum';
import { getNameMonth, numberToMillons } from '../../../utils/functions';
import KpiRemesaFuvexRow from './KpiRemesaFuvexRow';

interface PropsKpiRemesaFuvex {
  fuvex: {
    data: any;
    resume: {
      facturacion: number;
      mejorMesDia: number;
      mejorMes: number;
      comparativo: number;
      avance: number;
    };
    pages: { total: number; current: number; limit: number };
  };
  jfn: {
    data: any;
    resume: {
      facturacion: number;
      mejorMesDia: number;
      mejorMes: number;
      comparativo: number;
      avance: number;
    };
    pages: { total: number; current: number; limit: number };
  };
  values: { year: number; month: number };
  header: { bestMonth: number; bestMonthDay: string; currentDate: string };
  handleChangePageFuvex: (event: unknown, page: number) => Promise<void>;
  handleChangeRowsPerPageFuvex: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => Promise<void>;
  handleChangePageJfn: (event: unknown, page: number) => Promise<void>;
  handleChangeRowsPerPageJfn: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => Promise<void>;
}

const KpiRemesaFuvex: FC<PropsKpiRemesaFuvex> = ({
  fuvex,
  jfn,
  values,
  header,
  handleChangePageFuvex,
  handleChangeRowsPerPageFuvex,
  handleChangePageJfn,
  handleChangeRowsPerPageJfn,
}) => {
  const titleFuvex = 'Avance en remesa por Canales de Venta, En unidades, MM de PEN';
  const titleJefa = 'Avance en remesa por Jefa de Negocio, En unidades, MM de PEN';
  const nameBestMonth = getNameMonth(header.bestMonth);

  const headersFuvex = [
    { id: 1, name: 'Canales de Venta' },
    { id: 2, name: 'Facturación' },
    { id: 3, name: 'Facturación' },
    { id: 4, name: 'Facturación' },
    { id: 5, name: 'Comparativo' },
    { id: 6, name: 'Avance' },
    { id: 7, name: '' },
  ];

  const headersJefe = [
    { id: 1, name: 'Jefe de Negocio' },
    { id: 2, name: 'Facturación' },
    { id: 3, name: 'Facturación' },
    { id: 4, name: 'Facturación' },
    { id: 5, name: 'Comparativo' },
    { id: 6, name: 'Avance' },
    { id: 7, name: '', width: '20px' },
  ];

  return (
    <Box>
      <Box>
        <Title title={titleFuvex} />
        <Card>
          <Scrollbar>
            <Table size="small" className="zoominx2">
              <TableHead>
                <TableRow>
                  <TableCell style={{ border: 0 }} />
                  <TableCell
                    align="center"
                    style={{
                      background: '#134977',
                      color: 'white',
                      border: 0,
                      padding: '0px',
                    }}
                  >
                    Avance Mes Actual
                    <br />
                    {header.currentDate}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{
                      background: '#5ac4c4',
                      color: 'white',
                      border: 0,
                      padding: '0px',
                    }}
                  >
                    {`Mejor Mes ${values.year}`}
                    <br />
                    {header.bestMonthDay}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{
                      background: '#5ac4c4',
                      color: 'white',
                      border: 0,
                      padding: '0px',
                    }}
                  >
                    {`Mejor Mes ${values.year}`}
                    <br />
                    {nameBestMonth}
                  </TableCell>
                </TableRow>
                <TableRow>
                  {headersFuvex.map((headerItem, index) => {
                    let background = '#bfbfbf';
                    let color = '#134977';
                    if (index > 3) {
                      background = '#134977';
                      color = 'white';
                    }
                    return (
                      <TableCellHeaderBasic
                        key={headerItem.id}
                        style={{ background, color }}
                        align={index !== 0 ? 'center' : 'left'}
                      >
                        {headerItem.name}
                      </TableCellHeaderBasic>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {fuvex.data.map((item) => (
                  <KpiRemesaFuvexRow item={item} />
                ))}
              </TableBody>
              <TableHead>
                <TableRow>
                  <TableCellHeaderSum>Total</TableCellHeaderSum>
                  <TableCellHeaderSum align="right">
                    {numberToMillons(fuvex.resume.facturacion)}
                  </TableCellHeaderSum>
                  <TableCellHeaderSum align="right">
                    {numberToMillons(fuvex.resume.mejorMesDia)}
                  </TableCellHeaderSum>
                  <TableCellHeaderSum align="right">
                    {numberToMillons(fuvex.resume.mejorMes)}
                  </TableCellHeaderSum>
                  <TableCellHeaderSum align="center" style={{ padding: '0px' }}>
                    {fuvex.resume.comparativo}
                    %
                  </TableCellHeaderSum>
                  <TableCellHeaderSum align="center">
                    {fuvex.resume.avance}
                    %
                  </TableCellHeaderSum>
                  <TableCellHeaderSum />
                </TableRow>
              </TableHead>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 20]}
                    labelRowsPerPage="Registros por página"
                    labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                    count={fuvex.pages.total}
                    page={fuvex.pages.current}
                    rowsPerPage={fuvex.pages.limit}
                    onPageChange={handleChangePageFuvex}
                    onRowsPerPageChange={handleChangeRowsPerPageFuvex}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </Scrollbar>
        </Card>
      </Box>
      <Box pt={2}>
        <Title title={titleJefa} />
        <Card>
          <Scrollbar>
            <Table size="small" className="zoominx2">
              <TableHead>
                <TableRow>
                  <TableCell style={{ border: 0 }} />
                  <TableCell
                    align="center"
                    style={{ background: '#134977', color: 'white', border: 0 }}
                  >
                    Avance Mes Actual
                    <br />
                    {header.currentDate}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ background: '#5ac4c4', color: 'white', border: 0 }}
                  >
                    {`Mejor Mes ${values.year}`}
                    <br />
                    {header.bestMonthDay}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ background: '#5ac4c4', color: 'white', border: 0 }}
                  >
                    {`Mejor Mes ${values.year}`}
                    <br />
                    {nameBestMonth}
                  </TableCell>
                </TableRow>
                <TableRow>
                  {headersJefe.map((headerItem, index) => {
                    let background = '#bfbfbf';
                    let color = '#134977';
                    if (index > 3) {
                      background = '#134977';
                      color = 'white';
                    }
                    return (
                      <TableCellHeaderBasic
                        key={headerItem.id}
                        width={headerItem.width}
                        style={{ background, color }}
                        align={index !== 0 ? 'center' : 'left'}
                      >
                        {headerItem.name}
                      </TableCellHeaderBasic>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {jfn.data.map((item) => (
                  <TableRow key={item.jfn}>
                    <TableCell>{item.jfn}</TableCell>
                    <TableCell align="right">
                      {numberToMillons(item.facturacion)}
                    </TableCell>
                    <TableCell align="right">
                      {numberToMillons(item.mejorMesDia)}
                    </TableCell>
                    <TableCell align="right">
                      {numberToMillons(item.mejorMes)}
                    </TableCell>
                    <TableCell align="center">
                      {item.comparativo}
                      %
                    </TableCell>
                    <TableCell align="center">
                      {item.avance}
                      %
                    </TableCell>
                    <TableCell>
                      <img
                        src={`/static/images/${item.semaforo}.png`}
                        alt={item.semaforo}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableHead>
                <TableRow>
                  <TableCellHeaderSum>Total</TableCellHeaderSum>
                  <TableCellHeaderSum align="right">
                    {numberToMillons(jfn.resume.facturacion)}
                  </TableCellHeaderSum>
                  <TableCellHeaderSum align="right">
                    {numberToMillons(jfn.resume.mejorMesDia)}
                  </TableCellHeaderSum>
                  <TableCellHeaderSum align="right">
                    {numberToMillons(jfn.resume.mejorMes)}
                  </TableCellHeaderSum>
                  <TableCellHeaderSum align="center">
                    {jfn.resume.comparativo}
                    %
                  </TableCellHeaderSum>
                  <TableCellHeaderSum align="center">
                    {jfn.resume.avance}
                    %
                  </TableCellHeaderSum>
                  <TableCellHeaderSum />
                </TableRow>
              </TableHead>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 20]}
                    labelRowsPerPage="Registros por página"
                    labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                    count={jfn.pages.total}
                    page={jfn.pages.current}
                    rowsPerPage={jfn.pages.limit}
                    onPageChange={handleChangePageJfn}
                    onRowsPerPageChange={handleChangeRowsPerPageJfn}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </Scrollbar>
        </Card>
      </Box>
    </Box>
  );
};

export default KpiRemesaFuvex;
